/** Shared so the create dialog and the detail view cannot drift on how the fields are explained. */
export const attentionPurpose = "Used for invoicing purposes so the invoice can be addressed correctly.";
